import React from 'react'
import { graphql, StaticQuery } from 'gatsby'

import Logo from './header-components/logo'
import Scroll from './article-components/scrollToRead'

import footerStyles from './footer.module.scss'

const Footer = ({ className, children, hasNext, hideFooter }) => {
  return (
    <StaticQuery
      query={query}
      render={data => {
        const articleMetadata = data.site.siteMetadata.articleMetadata
        return (
          <div className="footer-container">
            <footer
              className={`container-fluid ${className} ${footerStyles.footer} ${
                hasNext ? footerStyles.footer__hasNext : ''
              } ${hideFooter ? footerStyles.hidden : ''}`}
            >
              <div className={`container`}>
                <div className="row">
                  {!hasNext ? (
                    <div className="col-xs-12">
                      <p className={footerStyles.partnerText}>
                        Esta reportagem foi realizada com o apoio da{' '}
                        <a
                          href="http://www.dgb.de/"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          DGB Bildungswerk
                        </a>
                        , no marco do projeto PN: 2017 2606 6/DGB 0014, sendo
                        seu conteúdo de responsabilidade exclusiva da Repórter
                        Brasil
                      </p>
                    </div>
                  ) : (
                    ''
                  )}
                  <div className={`col-xs-12 ${footerStyles.footerContents}`}>
                    {/* CREDITOS */}
                    <div className={footerStyles.credits}>
                      <h3 className={footerStyles.creditsTitle}>
                        {articleMetadata.creditsTitle}
                      </h3>
                      <dl className={footerStyles.creditsList}>
                        {articleMetadata.creditsContent.map((el, i) => (
                          <React.Fragment key={`frag${i}`}>
                            <dt
                              key={el.title}
                              className={footerStyles.itemTitle}
                            >
                              {el.title}
                            </dt>
                            {`: `}
                            <dd
                              key={el.name}
                              className={footerStyles.itemName}
                              itemProp="author"
                            >
                              {el.name}
                            </dd>
                            {i % 2 === 0 ? ` | ` : <br key={i} />}
                          </React.Fragment>
                        ))}
                      </dl>
                    </div>

                    {/* LOGO PARCEIROS */}
                    <div className={footerStyles.partnerLogo}>
                      {hasNext ? <p>Apoio:</p> : ''}
                      <img
                        alt="DGB Bildungswerk"
                        src="/velhochico/assets/DGB_BW_Logo_black.jpg"
                      />
                    </div>

                    {/* LOGO RPB */}
                    <div
                      className={`${footerStyles.logo} ${
                        hasNext ? footerStyles.down : ''
                      }`}
                    >
                      <Logo />
                    </div>

                    {/* MOUSE CTA */}
                    {hasNext ? <Scroll className={footerStyles.cta} /> : ''}
                  </div>
                </div>
              </div>
              {children && (
                <div className={footerStyles.waypointContainer}>{children}</div>
              )}
            </footer>
          </div>
        )
      }}
    />
  )
}

export default Footer

const query = graphql`
  query {
    site {
      siteMetadata {
        articleMetadata {
          creditsTitle
          creditsContent {
            title
            name
          }
        }
      }
    }
  }
`
